import React, { Component } from 'react';
import * as ReprintPackingSlipsAction from '../actions/ReprintPackingSlipsAction';
import ReprintPackingSlipsStore from '../stores/ReprintPackingSlipsStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import Autocomplete from 'react-autocomplete';
import swal from 'sweetalert';
import zIndex from '@material-ui/core/styles/zIndex';
//import axios from 'axios'
//import fileDownload from 'js-file-download'
let currentPagePath;
const style =
{
    // borderRadius: '3px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    // background: 'rgba(255, 255, 255, 0.9)',
    //padding: '2px 0',
    // fontSize: '90%',
    position: 'fixed',
    overflow: 'scroll',
    overflowX: 'hidden',
    maxHeight: '200px', // TODO: don't cheat, let it flow to the bottom
}

class ReprintPackingSlips extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.bindAttachments = this.bindAttachments.bind(this);
        this.state = {
            PickingDatedisable: true,
            Resetdisable: false,
            reprintdisable: false,
            PickingDate: "",
            pickDate: "",
            PickingDDDisable: false,
            autocompleteData: [],
            autoCompleteValue: "", lblerror: ""

        }
    }
    componentDidMount() {

        /*[2/24/22, PC_DP_10, Priyanka D]*/
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        this.Pageload();
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ReprintPackingSlipsAction.getCurrentFavPage(getFavPageBO);
        /*[05/18/22,WW-404_14], Priyanka D */
        ReprintPackingSlipsStore.on('PageloadResponse', this.PageloadResponse);
        ReprintPackingSlipsStore.on('PickDateResponse', this.BindPickDate);
        ReprintPackingSlipsStore.on('Reprint', this.Reprint);
        ReprintPackingSlipsStore.on('favpage', this.loadFavPageResponse.bind(this));
        ReprintPackingSlipsStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ReprintPackingSlipsStore.on('report', this.ReportResponse.bind(this));
    };
    /*[05/18/22,WW-404_07], Priyanka D */
    Pageload = () => {
        //CPW-90_PC_01 (3/12/2024)- Aparna
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        //console.log("DeepthiConsole", CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"));
        if (cribID == null || cribID == undefined || cribID == "" || cribID == " ") {

            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            let PageloadBO = {
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ReprintPackingSlipsAction.Pageload(PageloadBO)
        }
    }
    /*[05/18/22,WW-404_15], Priyanka D */
    PageloadResponse = () => {
        
        let OrdernumResponse = JSON.parse(ReprintPackingSlipsStore.PageloadRes);
        let autoCompleteDataRes = [];
        let lblerror = ""
        OrdernumResponse.Table.forEach((sugg, index) => {
            autoCompleteDataRes.push({ label: sugg.ORDER_NO, value: sugg.ORDER_NO });

        });
        /*[05/24/22,WW-404], Priyanka D */
        //let SuggestionResult =autoCompleteDataRes

        autoCompleteDataRes = autoCompleteDataRes.filter((ele, ind) => ind === autoCompleteDataRes.findIndex(elem => elem.value === ele.value && elem.label === ele.label))


        if (OrdernumResponse.Table1[0].DefaultCrib == "False") {
            lblerror = "Note: Please select crib ID from user profile. Order Detail is loaded based on the default crib C0W10"
            //alert("Please select Crib from user profile. Data is loaded based on the default crib C0W10")
        }
        this.setState({ autocompleteData: autoCompleteDataRes, autocompleteOptions: autoCompleteDataRes, lblerror: lblerror, SuggestionResult: OrdernumResponse });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    ReportResponse = () => {

    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Reprint Packing and Ship Doc",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ReprintPackingSlipsAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ReprintPackingSlipsAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(ReprintPackingSlipsStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (ReprintPackingSlipsStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ReprintPackingSlipsStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ReprintPackingSlipsStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    }
    clear = () => {

        this.setState({ autoCompleteValue: "", OrderNum: "", PickingDatedisable: true, Resetdisable: false, reprintdisable: false, PickingDate: "", PickingDDDisable: false });
    }
    HandlePickDate = (PickDate) => {
        
        let locPick = [];
        PickDate.map((item, index) => {
            let localArray = {
                value: item.ENDDTTM,
                label: item.ENDDTTM,
            }
            locPick.push(localArray)
        });
        this.setState({
            PickingDate: locPick, PickingDatedisable: false,
            Resetdisable: true,
            reprintdisable: true,
            pickDate: "",
            PickingDDDisable: true
        })
    }


    selectPickDate = () => {
        
        let EnddTTM = []
        let Date = []
        if (this.state.autoCompleteValue == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Enter the Order Number!"
            });
            // alert("Please Enter the Order Number!")
            return;
        }
        this.setState({
            OrderNum: this.state.autoCompleteValue
        })
        //let autoCompleteDataRes = this.state.SuggestionResult.Table.filter((ele, ind) => ind === this.state.autoCompleteValue.findIndex(elem => elem.ORDER_NO === ele.value && elem.label === ele.label))
        let PickDate = this.state.SuggestionResult.Table.filter((x) => x.ORDER_NO == this.state.autoCompleteValue)//WW-536
        console.log("SuggestionResult", PickDate)
        if (PickDate != null && PickDate != undefined && PickDate != "" && PickDate != " ") {
            PickDate.map((val, index) => {
                if (val.ENDDTTM != null) {
                    let obj = {
                        label: val.ENDDTTM,
                        value: val.ENDDTTM
                    }
                    EnddTTM.push(obj);
                }
            });
            if (EnddTTM != null && EnddTTM != undefined && EnddTTM != "" && EnddTTM != " ") {
                this.setState({
                    PickingDate: EnddTTM, PickingDatedisable: false,
                    Resetdisable: true,
                    reprintdisable: true,
                    pickDate: "",
                    PickingDDDisable: true
                })
            } else {

                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Pick Date is not available !!"
                });
                //alert("Pick Date is not available !!")
            }
        } else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let pickDateBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                OrderNum: this.state.autoCompleteValue,
                WalmartWeb: true
            };
            ReprintPackingSlipsAction.PickDate(pickDateBO);
        }
    }
    handlePickDateChange = (e) => {
        let pickDate = this.state.PickingDate.filter((item, index) => item.value == e.value);
        this.setState({ pickDate: pickDate });
    }
    ReprintClick = () => {
        
        //WW -364_PC_01 (4/13/2022) -Aparna
        let Orderno = this.state.autoCompleteValue
        let valid = true;
        if (Orderno == "" || Orderno == undefined || Orderno == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Enter the Order Number!"
            });
            //   alert("Please Enter the Order Number!");
            valid = false;
        }
        if (this.state.pickDate == undefined || this.state.pickDate == null || this.state.pickDate == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select Pick date"
            });
            //alert("Please Select Pick date");
            valid = false;
        }
        if (valid) {
            let ReprintBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                OrderNum: this.state.autoCompleteValue,
                pickDate: this.state.pickDate[0].value
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ReprintPackingSlipsAction.Reprint(ReprintBO);
        }

        // this.Reprint()
    }
    Reprint = () => {
        
        let Report = [];
        let arr = [];
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Reprint = JSON.parse(ReprintPackingSlipsStore.Reprint);
        if (Reprint.Report != null && Reprint.Report != undefined) {
            if (Reprint.Report.length > 0) {
                //CPW-90_PC_01
                //Reprint.Report.map((val, index) => {
                //    arr = val.REPORT.split('|')
                //    arr.map((val, index) => {
                //        if (val != "") {
                //            let localArray = {
                //                value: val,
                //            }
                //            Report.push(localArray)
                //        }

                //    })


                //});
                //}

                //this.setState({ Report: Report });
                //$('#ReportPopup').modal('show')
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Printed Successfully"
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Technical issue. Please contact SDI Customer Care"
                });
                //alert("Technical issue. Please contact SDI Customer Care")
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue. Please contact SDI Customer Care"
            });
            //alert("Technical issue. Please contact SDI Customer Care")
        }


    }
    //handleDownload = (url, filename) => {
    //    axios.get(url, {
    //        responseType: 'blob',
    //    })
    //        .then((res) => {
    //            fileDownload(res.data, filename)
    //        })
    //}
    bindAttachments = () => {
        
        let atatchmentdata = this.state.Report;
        let attach = "";
        if (atatchmentdata != null && atatchmentdata != undefined) {
            if (atatchmentdata.length > 0) {
                return atatchmentdata.map((attachment, index) => {
                    attach = attachment.value
                    attach = attach.replace(/\\/g, "/");

                    return (
                        <span className="attachment-file-name pl-0 my-2 d-inline-block" style={{ width: "87%" }} key={index}>
                            <a href={attachment.value} onClick={e => this.ReportDownload(e, attachment.value)} className="Attachment-overflow float-none" data-toggle="tooltip" title={attachment.value}>{attachment.value}</a>
                        </span>
                    );
                });
            }
        }
    };
    ReportDownload1 = (value) => {
        let BO = {
            FileName: value
        }
        ReprintPackingSlipsAction.ReportDownload(BO);
    }
    ReportDownload = (e, attachment) => {
        e.preventDefault();
        //WW -364_PC_02 (4/13/2022) -Aparna
        let filename = "Report"
        if (attachment.includes("Packing")) {
            filename = "PackingSlip.pdf"
        }
        else {
            filename = "ShippingSlip.pdf"
        }
        let downloadBO = {
            fileName: attachment,
            filePath: attachment,
            reprinttbool: true
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReprintPackingSlipsAction.ReportDownload1(downloadBO);
    };
    BindPickDate = () => {
        let locPick = [];
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PickingDate = JSON.parse(ReprintPackingSlipsStore.PickDateResponse);
        //WW-570_PC_05 (12/13/2022)-Aparna
        if (PickingDate.TransactionDate != null && PickingDate.TransactionDate != undefined) {
            if (PickingDate.TransactionDate.length > 0) {
                PickingDate.TransactionDate.map((val, index) => {
                    if (val.ENDDTTM != null) {
                        let localArray = {
                            value: val.ENDDTTM,
                            label: val.ENDDTTM,
                        }
                        locPick.push(localArray)
                    }
                });
                if (locPick != null && locPick != undefined && locPick != " " && locPick != "") {
                    this.setState({
                        PickingDate: locPick, PickingDatedisable: false,
                        Resetdisable: true,
                        reprintdisable: true,
                        pickDate: "",
                        PickingDDDisable: true
                    });
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Pick Date is not available !!"
                    });
                    // alert("Pick Date is not available !!")
                }

            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Order is not available for your crib"
                });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Order is not available for your crib"
            });
        }


    }

    clearAttaValid = (e) => {
        $('#ReportPopup').modal('hide');
        this.setState({ Report: [] });
    }
    /*[05/18/22,WW-404_02], Priyanka D */
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    /*[05/18/22,WW-404_03], Priyanka D */
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    /*[05/18/22,WW-404_04], Priyanka D */
    onChange(e) {
        let Typeaheadvalue = e.target.value.trim();
        const regex = /^[a-z0-9]+$/i;
        if (!regex.test(Typeaheadvalue) && Typeaheadvalue !== "") {
            return; 
        }

        if (this.state.PickingDatedisable == true) {
            let val = Typeaheadvalue.toUpperCase();
            let result = this.state.autocompleteOptions.filter(name => name.label.toUpperCase().includes(val));
            this.setState({
                autocompleteData: result, autoCompleteValue: Typeaheadvalue
            });
        }
    }
    /*[05/18/22,WW-404_05], Priyanka D */
    onSelect(val) {
        if (this.state.PickingDatedisable == true) {

            this.setState({
                autoCompleteValue: val
            });
        }
    }
    render() {
        return (
            <div class="container-fluid content-section">
                <div class="row justify-content-center">
                    <div class="col-md-12 page-heading mb-3">
                        <h5 class="page-title">Reprint Packing and Ship Doc</h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-OrdStatus">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="row justify-content-center">
                            <div className="col-md-10 col-lg-7">
                                <div className="sdi-shadow-bg">
                                    <div className="row justify-content-center align-items-center p-5">
                                        {/*<div className="">
                                                    <label className="catalog-label" htmlFor="itemId" style={{ "float: ": "left", "marginTop": "24px", "marginLeft": " 19px" }}>Order Number</label>
                                                //    <input  className="form-control" type="text" name="ItemID" disabled={!this.state.PickingDatedisable} id="itemId" style={{ "width": "48%", "marginTop": "18px", "float": "right", "marginRight": "159px", "border": "1px solid #ced4da", "borderRadius": "0.25rem" }} />
                                                  </div>*/}
                                        {/*[05/18/22,WW-404_01], Priyanka D sdi-reprint */}
                                        <div className="col-lg-8 col-md-10 text-center" style={{ zIndex: "999" }} disabled={!this.state.PickingDatedisable}>
                                            {this.state.PickingDatedisable ?
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.autocompleteData}
                                                    renderItem={this.renderItem}
                                                    value={this.state.autoCompleteValue}
                                                    onChange={this.onChange}
                                                    onSelect={this.onSelect}
                                                    style={{ zIndex: '9999' }}
                                                    inputProps={{ placeholder: "Order number", className: "search-ordernum" }}
                                                    menuStyle={style}
                                                /> :
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.autocompleteData}
                                                    renderItem={this.renderItem}
                                                    value={this.state.autoCompleteValue}
                                                    onChange={this.onChange}
                                                    onSelect={this.onSelect}
                                                    inputProps={{ placeholder: "Order number", className: "disabled search-ordernum" }}
                                                    menuStyle={style}
                                                />}
                                        </div>

                                        {this.state.PickingDDDisable ?
                                            <div className="col-lg-8 col-md-10 Contentdiv my-3">
                                                <span className="row justify-content-center">
                                                    <Select
                                                        id="AreaId"
                                                        name="Area"
                                                        options={this.state.PickingDate}
                                                        value={this.state.pickDate} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                        onChange={(e) => this.handlePickDateChange(e)}
                                                        placeholder="Pick Date"
                                                        className="col-md-11 col-lg-11 css-2b097c-container"
                                                    /></span> </div> : null}
                                        {this.state.PickingDatedisable ?
                                            <div className="col-md-8 text-center my-3">
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={e => this.selectPickDate(e)} >Select Pick Date</button>
                                            </div> : null}
                                        <div className="col-md-8">
                                            <div className="row justify-content-center">
                                                {this.state.Resetdisable ?
                                                    <div className="mr-2 mb-3">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" style={{ "width": "154px" }} onClick={e => this.clear()} >Reset</button>
                                                    </div> : null}
                                                {this.state.reprintdisable ?
                                                    <div className="mr-2">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" style={{ "width": "154px" }} onClick={e => this.ReprintClick(e)} >Reprint</button>
                                                    </div> : null}
                                            </div>

                                        </div>


                                    </div>
                                </div>


                                <label className="priority-alert mt-4" id="lblerror" style={{}}>{this.state.lblerror}</label>
                            </div>




                        </div>
                    </div>
                </div>

                <div className="modal" id="ReportPopup" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Reports</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.clearAttaValid()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    {/* <label className="col-md-5"><Trans>Select file to attach</Trans></label>*/}
                                    <div className="col-md-7">
                                        {/*<label className="file">
                                            <input type="file" title=" " id="ShopCartcustomFile" name="filename" multiple aria-label="File browser example" onChange={e => this.handleAttachment(e)} />
                                            <span className="file-custom" />
                                        </label>*/}
                                        {this.bindAttachments()}

                                        {/*<span className="attachment-file-name pl-0 my-2 d-inline-block"><a href="#">Something.png</a><span className="attachment-remove-icon ml-1">X</span></span>*/}
                                        <span className="float-left err-msg text-danger" id="AttachError"></span>
                                    </div>
                                </div>
                                {/* <div className="col-md-12 mt-2 text-right p-0">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" onClick={e => this.cancelbuttonclick()}><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.PopupForLineLevelDetails(this.state.SelectedIndex, "", "ADB")}><Trans>Attach</Trans></button>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}
export default withTranslation()(ReprintPackingSlips);